let preImportTime: number | undefined;
try {
    preImportTime = performance.now();
} catch {}

export function getPreImportTime() {
    return preImportTime;
}
